import React from 'react';
import { BottomBar } from '../../../components/containers';
import { Button } from '../../../components/actions';
import { connect } from 'react-redux';
import { getHistoryManageModeIsOn, getHistoryManageModeSelectedEntries } from '../../../selectors';
import s from './index.css';
import { deleteReportsFromHistory, toggleReportsHistoryManageMode, refreshLastReportsHistoryPage } from '../action';
import { updateLocale } from 'moment';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({
    manageModeIsOn: getHistoryManageModeIsOn(state),
    selectedEntries: getHistoryManageModeSelectedEntries(state),
});

const mapDispatchToProps = dispatch => ({
    toggleReportsHistoryManageMode: bindActionCreators(toggleReportsHistoryManageMode, dispatch),
    deleteReportsFromHistory: bindActionCreators(deleteReportsFromHistory, dispatch),
    refreshLastReportsHistoryPage: bindActionCreators(refreshLastReportsHistoryPage, dispatch),
});

class HistoryMangeBar extends React.Component {
    DELETE_STATUS = {
        None: 'none',
        Deleting: 'deleting',
        Success: 'success',
        Error: 'error',
    };

    state = {
        label: 'Select reports to remove from history',
        status: this.DELETE_STATUS.None,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            prevState &&
            nextProps &&
            this &&
            this.props &&
            nextProps.manageModeIsOn &&
            this.props.manageModeIsOn !== nextProps.manageModeIsOn
        ) {
            return {
                ...prevState,
                status: this.DELETE_STATUS.None,
            };
        }

        return null;
    }

    render() {
        return (
            <BottomBar show={this.props.manageModeIsOn}>
                <div>
                    <p className={s.description}>
                        {(this.props.selectedEntries.length <= 0 && <strong>{this.state.label}</strong>) ||
                            this.state.label}
                    </p>
                </div>

                <div>
                    {(this.props.selectedEntries.length > 0 && (
                        <Button
                            onClick={this.handleDelete}
                            design={
                                this.state.status === this.DELETE_STATUS.Deleting ||
                                this.state.status === this.DELETE_STATUS.Success
                                    ? 'blue'
                                    : 'warning'
                            }
                            label={
                                this.state.status === this.DELETE_STATUS.Error
                                    ? 'Could not remove, click here to try again'
                                    : this.state.status === this.DELETE_STATUS.Deleting
                                        ? 'Removing reports...'
                                        : this.state.status === this.DELETE_STATUS.Success
                                            ? 'Removed reports'
                                            : 'Delete selected reports'
                            }
                        />
                    )) ||
                        (this.state.status === this.DELETE_STATUS.Success && (
                            <p className={s.success}>Removed reports</p>
                        )) || <Button onClick={this.handleCancelManageMode} design="yellow" label="Cancel" />}
                </div>
            </BottomBar>
        );
    }

    handleDelete = e => {
        if (this.props.selectedEntries && this.props.selectedEntries.length > 0) {
            this.setState({
                status: this.DELETE_STATUS.Deleting,
            });

            this.props
                .deleteReportsFromHistory(this.props.selectedEntries)
                .then(success => {
                    this.setState({
                        status: this.DELETE_STATUS.Success,
                    });

                    setTimeout(() => {
                        if (this.state.status === this.DELETE_STATUS.Success) {
                            this.setState({
                                status: this.DELETE_STATUS.None,
                            });
                        }

                        if (!(this.props.selectedEntries && this.props.selectedEntries.length > 0)) {
                            this.props.toggleReportsHistoryManageMode(false);
                        }
                    }, 3000);

                    this.props.refreshLastReportsHistoryPage();
                })
                .catch(error => {
                    this.setState({ status: this.DELETE_STATUS.Error });
                });
        } else {
            this.props.toggleReportsHistoryManageMode(false);
        }
    };

    handleCancelManageMode = e => {
        this.props.toggleReportsHistoryManageMode(false);
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HistoryMangeBar);



// WEBPACK FOOTER //
// ./app/web/src/container/ReportsPage/HistoryManageBar/index.jsx